import { useUserStore } from '~/stores/user'

/**
 * The currently logged in user is of user.kind 'band'
 */
export default defineNuxtRouteMiddleware(() => {
  const { $localePath, $pinia } = useNuxtApp()
  const { IS_BAND } = useUserStore($pinia)

  if (!IS_BAND) return navigateTo($localePath('/'))
})
